import React, { useState, useRef, useEffect } from 'react'
import message from '../../original-code/antd-message'
import { Popup } from '../../baseComponent/v2'
import AuditLevelsSelect from '../auditLevelsSelect'
import Icon from '../icon'
import { teamHasAuth } from '../../utils/auth'
import globalData from '../../common/globalData'
import noPermissionPrompt from '../useFunModal/noPermissionPrompt'
import request from '../../utils/request'
import mes from '../../utils/message'
import Modal from '../modal'
import Input from '../../baseComponent/input'
import Loading from '../../baseComponent/loading'
import Cooperation from './cooperation'
import ChooseStyleTaskModal from './chooseStyleTask'
import InspirationType from './inspirationType'
import './index.less'

export default (props) => {
  const { children, onClick, style, className, onChange, onChooseTaskOk, onChooseTaskClose, onOk } = props
  const [visible, setVisible] = useState(false)

  const onClickTrigger = (e) => {
    e && e.stopPropagation()
    setVisible(true)
    onClick && onClick()
  }

  return (
    <>
      <a onClick={onClickTrigger} style={style} className={className}>
        {children || '新建灵感集'}
      </a>
      {visible && (
        <CreateIdeaMassModal
          visible={visible}
          setVisible={setVisible}
          onChange={onChange}
          onChooseTaskOk={onChooseTaskOk}
          onChooseTaskClose={onChooseTaskClose}
          onOk={onOk}
        />
      )}
    </>
  )
}

export const CreateIdeaMassModal = ({
  visible,
  setVisible,
  parentId,
  onCancel,
  onChange,
  onChooseTaskOk,
  onChooseTaskClose,
  onOk,
  disabledTask, // 禁止选款任务
  trackSource = '采集时新建',
}) => {
  const [users, setUsers] = useState([])
  const [ideaMass, setIdeaMass] = useState({})
  const inspirationId = useRef(null)
  const tempSaveInspirationInfo = useRef(null)
  const [taskVisible, setTaskVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    if (!teamHasAuth('meinian_inspiration_pro')) {
      setIdeaMass({
        needMarkTimes: 1,
        isPro: 0,
      })
    } else {
      const flag = await globalData.toGet('create_meinian_inspiration_pro')
      const _isPro = flag === null ? 1 : Number(flag)
      request.get('/ins/inspiration/work/platform/get-team-need-mark-times').then((res) => {
        setIdeaMass({
          needMarkTimes: res,
          isPro: _isPro,
        })
      })
    }
  }

  const create = async () => {
    setLoading(true)
    try {
      const res = await request.post('/zhikuan/ins/inspiration/save-inspiration-info', {
        ...ideaMass,
        parentId,
        cooperationUserList: users
          .filter((m) => m.role)
          .map((m) => ({
            role: m.role,
            userId: m.userId,
          })),
      })
      inspirationId.current = res
      message.success(
        <span>
          已成功新建灵感集
          <a
            className="link"
            style={{ color: '#0065D9' }}
            href={`/meinian/home/coll/detail/${res}?inspirationId=${res}`}
            target="_blank"
            rel="noreferrer"
          >
            {ideaMass.name}
          </a>
        </span>
      )
      tempSaveInspirationInfo.current = res
      onChange?.(res, { ...ideaMass, id: res }) // 返回创建成功的id
      mes.pub('onMNCreateIns')
      setLoading(false)
      return true
    } catch (err) {
      setLoading(false)
      return false
    }
  }

  const onSubmit = async () => {
    if (!ideaMass.name?.trim()) {
      message.error('灵感集的名称不能为空哦')
      return false
    }
    if (ideaMass.isPro) {
      const flag = await create()
      if (flag && !disabledTask) {
        setTaskVisible(true)
      }
      return flag
    }
    const flag = await onOk?.()
    await create()
    if (flag === false) {
      return
    }
    setVisible(false)
  }

  return (
    <div>
      {visible && (
        <Modal
          title="新建灵感集"
          className="mn-create-idea-mass-modal"
          visible={visible}
          onVisibleChange={(_visible) => setVisible(_visible)}
          okText="确定"
          onCancel={onCancel}
          onOk={() => onSubmit()}
          style={{ width: 640 }}
        >
          <Loading spinning={loading}>
            <div className="content" style={{ paddingBottom: '16px' }}>
              <div className="item-name required">名称</div>
              <Input
                wrapClassName="item-input"
                maxLength={20}
                value={ideaMass.name}
                placeholder="请输入灵感集名称，不超过20个字"
                onChange={(e) => {
                  const name = e.target.value
                  setIdeaMass((pre) => ({ ...pre, name }))
                }}
                suffix={`${ideaMass?.name?.length || 0}/20`}
              />
              <div className="item-name">设置协作</div>
              <Cooperation
                trackSource={trackSource}
                hiddenLastSet
                onChange={(_users) => setUsers(_users)}
                usersListStyle={{ height: '400px' }}
              />
              <div className="item-name">
                灵感集类型
                <span>
                  <Icon type="m-bangzhu_miaobian" className="item-name-inspiration-type-tip-icon" />
                  <Popup arrow className="item-name-inspiration-bubble">
                    {!ideaMass.isPro
                      ? '图片采集，管理和查看，比较简洁，适用于有图档管理需求的团队'
                      : '图片采集，管理和查看，团队协作功能，适用于有团队协作需求的团队'}
                  </Popup>
                </span>
              </div>
              <InspirationType
                value={ideaMass.isPro}
                onChange={(val) => {
                  if (teamHasAuth('meinian_inspiration_pro')) {
                    globalData.set('create_meinian_inspiration_pro', val)
                    setIdeaMass((pre) => ({ ...pre, isPro: val }))
                  } else {
                    noPermissionPrompt({})
                  }
                }}
              />
              {teamHasAuth('meinian_mark_times') && (
                <>
                  <div className="item-name">审核层级</div>
                  <AuditLevelsSelect
                    className="mn-create-idea-mass-select"
                    value={ideaMass.needMarkTimes}
                    onChange={(val) => {
                      setIdeaMass((pre) => ({ ...pre, needMarkTimes: val }))
                    }}
                  />
                </>
              )}
            </div>
          </Loading>
        </Modal>
      )}
      {taskVisible ? (
        <ChooseStyleTaskModal
          visible={taskVisible}
          inspirationName={ideaMass.name}
          setVisible={setTaskVisible}
          setCooperationVisible={setVisible}
          create={create}
          inspirationId={inspirationId.current}
          type="inspirationCreate"
          onOk={onChooseTaskOk}
          onClose={onChooseTaskClose}
        />
      ) : null}
    </div>
  )
}
